<template>
    <div class="goods-analysis" v-loading="loading">
        <div>
            <!-- <div class="title"><span class="title-c">数据总览</span>每天0点左右更新前一日数据</div>
            <el-card class="box-card">
                <div class="data-count">
                    <div class="data-item">
                        <p>3天出货量</p>
                        <p>{{ statData.DaysAmount }}</p>
                    </div>
                    <div class="data-item">
                        <p>7天出货量</p>
                        <p>{{ statData.WeekAmount }}</p>
                    </div>
                    <div class="data-item">
                        <p>15天出货量</p>
                        <p>{{ statData.TWeekAmount }}</p>
                    </div>
                    <div class="data-item">
                        <p>30天出货量</p>
                        <p>{{ statData.MonthAmount }}</p>
                    </div>
                    <div class="data-item">
                        <p>年度出货量</p>
                        <p>{{ statData.YearAmount }}</p>
                    </div>
                    <div class="data-item">
                        <p>最长回货期</p>
                        <p>
                            {{ statData.LBackPeriods > 0 ? (statData.LBackPeriods / 24).toFixed(1) : '-' }}
                        </p>
                    </div>
                    <div class="data-item border-right-none">
                        <p>最短回货期</p>
                        <p>
                            {{ statData.SBackPeriods > 0 ? (statData.SBackPeriods / 24).toFixed(1) : '-' }}
                        </p>
                    </div>
                </div>
            </el-card> -->
            <div class="echart-ctn" id="echartStn"></div>
            <div class="toggle-year">
                <span>天数：</span>
                <el-button size="small" @click="updateDayData(0)" :type="this.searchYearData.Type == 0 ? 'primary' : ''">7天</el-button>
                <el-button size="small" @click="updateDayData(1)" :type="this.searchYearData.Type == 1 ? 'primary' : ''">30天</el-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['GoodsId', 'StoId'],
    components: {},
    data() {
        return {
            loading: false,
            searchYearData: {
                GoodsId: '',
                StoId: '',
                Type: 0
            },
            date: [],
            series: [],
            statData: {},
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            }
        };
    },
    mounted() {
        this.searchYearData.GoodsId = this.GoodsId;
        this.searchYearData.StoId = this.StoId;
        this.getData();
    },
    methods: {
        // 更新表格数据
        updateDayData(type) {
            this.searchYearData.Type = type;
            this.getData();
        },
        generateLast7Days() {
            const today = new Date();
            const last7Days = [];

            for (let i = 0; i < 7; i++) {
                const date = new Date(today);
                date.setDate(date.getDate() - i); // 减去i天
                const dateString = date.toISOString().split('T')[0]; // 转换为YYYY-MM-DD格式
                last7Days.push(dateString);
            }

            return last7Days.reverse();
        },
        generateLast30Days() {
            const today = new Date();
            const last30Days = [];

            for (let i = 0; i < 30; i++) {
                const date = new Date(today);
                date.setDate(date.getDate() - i); // 减去i天
                const dateString = date.toISOString().split('T')[0]; // 转换为YYYY-MM-DD格式
                last30Days.push(dateString);
            }

            return last30Days.reverse();
        },
        getData() {
            let that = this;
            that.loading = true;
            if (this.searchYearData.Type == 0) this.date = this.generateLast7Days();
            else this.date = this.generateLast30Days();
            that.$util
                .axiosGet({
                    url: '/api/DataStatistics/GoodsSaleStat',
                    data: this.searchYearData
                })
                .then(res => {
                    let _series = [];
                    let data = res.data.stat;
                    for (let i = 0; i < data.length; i++) {
                        _series.push({
                            name: data[i].name,
                            type: 'line',
                            data: data[i].data
                        });
                    }
                    this.series = _series;
                    this.initEchart();
                    that.loading = false;
                })
                .catch(() => {
                    that.loading = false;
                });
        },
        initEchart() {
            // 基于准备好的dom，初始化echarts实例
            let myChart = this.$echarts.init(document.getElementById('echartStn'));
            // 绘制图表
            myChart.setOption({
                title: {
                    text: '销售数图'
                },
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {}
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: this.date
                },
                yAxis: {
                    type: 'value'
                },
                series: this.series
            });
        }
    }
};
</script>
<style lang="less" scoped>
.data-count {
    padding: 15px;
    display: flex;
    .data-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 13.8%;
        border-right: 1px solid @border4Color;
        > p:nth-child(1) {
            margin-bottom: 10px;
        }
    }
}
.echart-ctn {
    height: 300px;
    margin-top: 20px;
}
.goods-analysis {
    position: relative;
}
.toggle-year {
    position: absolute;
    top: 0px;
    left: 100px;
}
.title {
    margin-left: 10px;
    margin-bottom: 10px;

    .title-c {
        font-size: 16px;
        font-weight: bold;
        color: black;
        margin-right: 10px;
    }
}
</style>
